export const translations = {
  en: {
    nav: {
      services: "Services",
      work: "How it works",
      pricing: "Pricing",
      portfolio: "Portfolio",
      contact: "Contact",
      cta: "Book Free Call",
    },
    hero: {
      eyebrow: "AI-Powered Digital Launch Partner",
      titleA: "Launch your business online,",
      titleB: "fast & beautifully.",
      subtitle:
        "Stop paying lakhs to slow agencies. We use AI to design, build & launch your website, social media and brand — in days, not months.",
      ctaPrimary: "Launch My Business",
      ctaSecondary: "Talk on WhatsApp",
      callNow: "Call Now",
      trustA: "Trusted by 200+ Indian businesses",
      trustB: "Avg launch in 5 days",
      trustC: "₹4,999 onwards",
    },
    stats: {
      a: "Businesses Launched",
      b: "Avg Days to Launch",
      c: "Cheaper than Agencies",
      d: "Customer Rating",
    },
    problem: {
      eyebrow: "The Old Way vs The Mitra Way",
      title: "Why pay lakhs when AI can do it smarter?",
      subtitle: "Traditional IT agencies are slow, costly and over-engineered. We are the modern alternative built for Indian SMBs.",
      oldTitle: "Traditional Agency",
      newTitle: "Launch Mitra",
      old: [
        "₹50,000 – ₹5,00,000 quotes",
        "2–6 months delivery",
        "Endless meetings & emails",
        "Confusing tech jargon",
        "Hidden costs & add-ons",
        "Cookie-cutter templates",
      ],
      new: [
        "Starts at just ₹4,999",
        "Live in 3–7 days",
        "WhatsApp-first communication",
        "Plain Hindi/English explanations",
        "Transparent flat pricing",
        "Custom AI-crafted designs",
      ],
    },
    how: {
      eyebrow: "How We Work",
      title: "Four simple steps. Zero stress.",
      subtitle: "From idea to live business — we handle the tech so you can focus on customers.",
      steps: [
        { t: "Tell us your idea", d: "Share your business on a quick WhatsApp call. No tech knowledge needed." },
        { t: "AI designs your brand", d: "Our AI + designers craft a website, logo & social pages tailored to your business." },
        { t: "You review & approve", d: "We send a live preview. Tweak anything until it feels perfectly yours." },
        { t: "Launch & grow", d: "We go live, set up domain, social handles and you start getting customers." },
      ],
    },
    services: {
      eyebrow: "What We Build",
      title: "Everything your business needs to look pro online.",
      list: [
        { t: "Business Websites", d: "Modern, fast, mobile-first sites that convert visitors into customers.", tag: "Most Loved" },
        { t: "AI Website Generation", d: "Premium custom design built by AI in hours — not weeks." },
        { t: "Social Media Setup", d: "Instagram, Facebook & Google profiles configured and verified." },
        { t: "Monthly Post Creation", d: "12–20 scroll-stopping posts every month, designed for your brand." },
        { t: "Branding & Logo", d: "Logo, colors, fonts & brand kit that make you look premium." },
        { t: "Digital Setup", d: "Domain, hosting, email, WhatsApp Business — all done for you." },
        { t: "Startup Launch Kit", d: "Pitch deck, landing page & launch posts to get your first 100 customers." },
      ],
    },
    portfolio: {
      eyebrow: "Recent Launches",
      title: "Real businesses. Real results.",
      subtitle: "A glimpse of what we've built — from local cafes in India to international software brands.",
      items: [
        { t: "The Street Brews", c: "Cafe · India", k: "Live website + online ordering", url: "https://thestreetbrews.com", design: "cafe" },
        { t: "MK Khambati & Co", c: "Iron & Steel · Indore (since 1952)", k: "5x faster ops · 40% less manpower", design: "industrial", proud: "A name every business in Indore trusts — and we got to build their digital future." },
        { t: "IMX Warehouse Suite", c: "International · Logistics", k: "Pool of 5 software products + websites", design: "tech" },
        { t: "Saanvi Boutique", c: "Jaipur · Fashion", k: "+3x Instagram reach", design: "fashion" },
      ],
    },
    pricing: {
      eyebrow: "Pricing",
      title: "Big agency quality. Small business price.",
      subtitle: "Pick a plan that fits. All plans include design, build, launch and dedicated support.",
      monthly: "One-time",
      popular: "Most Popular",
      cta: "Get Started",
      urgencyBadge: "🎁 Limited time offer",
      finePrint: "* Yearly maintenance billed separately",
      tiers: [
        {
          name: "Starter",
          price: "₹4,999",
          tag: "Perfect for shops & solo owners",
          urgency: "Get 1 month FREE social media (posts + posting) with this plan",
          features: [
            "Beautiful 1-page website",
            "Looks great on mobile",
            "WhatsApp & Call buttons",
            "No monthly server cost",
            "Live in 3–7 days",
            "Free support for 30 days",
          ],
          fineprint: "Yearly maintenance charged separately (very small)",
        },
        {
          name: "Growth",
          price: "₹14,999",
          tag: "For most growing businesses",
          features: [
            "5-page premium website",
            "Logo + brand kit",
            "Instagram + Google Business setup",
            "8 social media posts (1 month free)",
            "Lead form + WhatsApp chat",
            "Show up on Google searches",
            "60 days support",
          ],
        },
        {
          name: "Pro",
          price: "₹29,999",
          tag: "For software, e-commerce & dynamic apps",
          features: [
            "Custom business software / app",
            "Online shop / e-commerce ready",
            "Customer login & dashboards",
            "Online payments (UPI, cards)",
            "Full branding package",
            "20 social posts/month for 3 months",
            "Founder-led delivery & priority support",
          ],
        },
      ],
      custom: {
        eyebrow: "Need something different?",
        title: "We also build custom plans.",
        sub: "Got a unique idea? Bigger requirement? We'll design a plan that fits your business and budget perfectly.",
        cta: "Get My Custom Plan",
        bullets: ["Tailored to your needs", "Talk to a founder directly", "Free 15-min consultation"],
      },
    },
    testimonials: {
      eyebrow: "Loved by Indian Businesses",
      title: "Stories from real owners.",
      list: [
        { n: "Rohit Mehta", r: "Owner, Bombay Brew Cafe", q: "Got my website + Instagram done in 4 days. My customers say it looks 'imported'! Worth every rupee.", a: 1 },
        { n: "Dr. Priya Iyer", r: "Founder, Iyer Wellness", q: "I had no idea where to start. Mitra team handled everything on WhatsApp. Now I get 10+ bookings online every week.", a: 2 },
        { n: "Arjun Singh", r: "Owner, Iron Den Gym", q: "Other agencies quoted ₹85,000. These guys did better work in ₹15,000. Genuine, fast and creative.", a: 3 },
        { n: "Saanvi Khanna", r: "Founder, Saanvi Boutique", q: "The Instagram posts they create every month are stunning. My reach tripled in 60 days.", a: 2 },
      ],
    },
    trust: {
      eyebrow: "Why Launch Mitra",
      title: "AI-powered. Human-supported. Founder-led.",
      points: [
        { t: "Fast turnaround", d: "Most projects live in under 7 days." },
        { t: "Truly affordable", d: "AI keeps costs 70% lower than agencies." },
        { t: "Real humans on WhatsApp", d: "Talk to a real person, not a chatbot." },
        { t: "Founder-led quality", d: "Every project reviewed by our founders." },
        { t: "Made for Indian SMBs", d: "Hindi + English support, UPI, WhatsApp built-in." },
        { t: "Transparent pricing", d: "Flat rates. No hidden fees. Ever." },
      ],
    },
    cta: {
      title: "Ready to launch your business online?",
      sub: "Free 15-min strategy call. No commitment, no jargon. Just clear next steps.",
      primary: "Book Free Consultation",
      secondary: "WhatsApp Us",
    },
    form: {
      title: "Let's launch your business",
      sub: "Share a few details and we'll call you within 30 minutes.",
      name: "Your name",
      phone: "Phone / WhatsApp",
      type: "Business type",
      typePh: "e.g. Cafe, Clinic, Gym",
      message: "Tell us about your business (optional)",
      submit: "Send Inquiry",
      submitting: "Sending…",
      success: "Got it! We'll call you within 30 mins on WhatsApp.",
      error: "Something went wrong. Please try again or call us directly.",
    },
    footer: {
      tagline: "AI-powered digital launch partner for Indian small businesses.",
      sections: { product: "Product", company: "Company", contact: "Contact" },
      links: {
        services: "Services",
        pricing: "Pricing",
        portfolio: "Portfolio",
        about: "About",
        process: "Process",
        privacy: "Privacy",
      },
      rights: "All rights reserved.",
      built: "Designed & built by Launch Mitra — using our own AI workflow.",
    },
    sticky: { call: "Call", whatsapp: "WhatsApp", launch: "Launch My Business" },
  },

  hi: {
    nav: {
      services: "सेवाएं",
      work: "प्रक्रिया",
      pricing: "कीमत",
      portfolio: "उदाहरण",
      contact: "संपर्क",
      cta: "मुफ्त कॉल बुक करें",
    },
    hero: {
      eyebrow: "AI-संचालित डिजिटल लॉन्च पार्टनर",
      titleA: "अपना बिज़नेस ऑनलाइन लाएँ,",
      titleB: "तेज़ और शानदार।",
      subtitle:
        "महंगी एजेंसियों को लाखों मत दीजिए। हम AI से आपकी वेबसाइट, सोशल मीडिया और ब्रांड बनाते हैं — महीनों में नहीं, दिनों में।",
      ctaPrimary: "मेरा बिज़नेस लॉन्च करें",
      ctaSecondary: "WhatsApp पर बात करें",
      callNow: "अभी कॉल करें",
      trustA: "200+ भारतीय बिज़नेस का भरोसा",
      trustB: "औसत 5 दिन में लॉन्च",
      trustC: "₹4,999 से शुरू",
    },
    stats: {
      a: "बिज़नेस लॉन्च हुए",
      b: "औसत लॉन्च दिन",
      c: "एजेंसी से सस्ता",
      d: "ग्राहक रेटिंग",
    },
    problem: {
      eyebrow: "पुराना तरीका बनाम मित्र तरीका",
      title: "लाखों क्यों दें जब AI स्मार्ट तरीके से कर सकता है?",
      subtitle: "पुरानी एजेंसियाँ धीमी, महंगी और जटिल हैं। हम भारतीय SMB के लिए बने हैं।",
      oldTitle: "पुरानी एजेंसी",
      newTitle: "Launch Mitra",
      old: [
        "₹50,000 – ₹5,00,000 क्वोट",
        "2–6 महीने का समय",
        "अंतहीन मीटिंग्स और ईमेल",
        "जटिल टेक भाषा",
        "छुपे हुए ख़र्चे",
        "साधारण टेम्पलेट्स",
      ],
      new: [
        "मात्र ₹4,999 से शुरू",
        "3–7 दिनों में लाइव",
        "WhatsApp पर सीधा संवाद",
        "हिंदी/अंग्रेज़ी में सरल बात",
        "पारदर्शी फ्लैट कीमत",
        "AI से बनाए कस्टम डिज़ाइन",
      ],
    },
    how: {
      eyebrow: "कैसे काम करते हैं",
      title: "चार आसान कदम। ज़ीरो टेंशन।",
      subtitle: "आइडिया से लाइव बिज़नेस तक — टेक हम संभालेंगे।",
      steps: [
        { t: "अपना आइडिया बताइए", d: "एक छोटी WhatsApp कॉल पर अपना बिज़नेस बताइए। टेक की कोई ज़रूरत नहीं।" },
        { t: "AI आपका ब्रांड बनाता है", d: "AI और डिज़ाइनर मिलकर वेबसाइट, लोगो और सोशल पेज बनाते हैं।" },
        { t: "आप रिव्यू और अप्रूव करें", d: "लाइव प्रीव्यू भेजते हैं। जब तक आप ख़ुश नहीं — बदलाव होते रहेंगे।" },
        { t: "लॉन्च और ग्रोथ", d: "डोमेन, सोशल हैंडल सब सेटअप करके आपको ग्राहक मिलने शुरू।" },
      ],
    },
    services: {
      eyebrow: "हम क्या बनाते हैं",
      title: "ऑनलाइन प्रो दिखने के लिए सब कुछ।",
      list: [
        { t: "बिज़नेस वेबसाइट", d: "मॉडर्न, फ़ास्ट, मोबाइल-फर्स्ट साइट्स जो ग्राहक लाती हैं।", tag: "Most Loved" },
        { t: "AI वेबसाइट जनरेशन", d: "AI से बनी प्रीमियम कस्टम डिज़ाइन — हफ्तों में नहीं, घंटों में।" },
        { t: "सोशल मीडिया सेटअप", d: "Instagram, Facebook और Google प्रोफाइल — सेट और वेरिफाइड।" },
        { t: "मासिक पोस्ट क्रिएशन", d: "हर महीने 12–20 आकर्षक पोस्ट, आपके ब्रांड के लिए।" },
        { t: "ब्रांडिंग और लोगो", d: "लोगो, रंग, फॉन्ट और ब्रांड किट जो प्रीमियम दिखे।" },
        { t: "डिजिटल सेटअप", d: "डोमेन, होस्टिंग, ईमेल, WhatsApp Business — सब हम करेंगे।" },
        { t: "स्टार्टअप लॉन्च किट", d: "पिच डेक, लैंडिंग पेज और लॉन्च पोस्ट — पहले 100 ग्राहकों के लिए।" },
      ],
    },
    portfolio: {
      eyebrow: "हाल के लॉन्च",
      title: "असली बिज़नेस। असली रिज़ल्ट।",
      subtitle: "स्थानीय कैफ़े से लेकर इंटरनेशनल सॉफ्टवेयर ब्रांड तक — कुछ काम जिन पर हमें गर्व है।",
      items: [
        { t: "The Street Brews", c: "कैफ़े · इंडिया", k: "लाइव वेबसाइट + ऑनलाइन ऑर्डर", url: "https://thestreetbrews.com", design: "cafe" },
        { t: "MK Khambati & Co", c: "लोहा और इस्पात · इंदौर (सन् 1952 से)", k: "5x तेज़ ऑपरेशन · 40% कम मैनपावर", design: "industrial", proud: "इंदौर का हर बिज़नेस जानता है — और उनका डिजिटल फ़्यूचर हमने बनाया।" },
        { t: "IMX Warehouse Suite", c: "इंटरनेशनल · लॉजिस्टिक्स", k: "5 सॉफ्टवेयर + वेबसाइट का सूट", design: "tech" },
        { t: "Saanvi Boutique", c: "जयपुर · फ़ैशन", k: "+3x Instagram रीच", design: "fashion" },
      ],
    },
    pricing: {
      eyebrow: "कीमत",
      title: "बड़ी एजेंसी जैसी क्वालिटी। छोटे बिज़नेस वाली कीमत।",
      subtitle: "अपना प्लान चुनिए। हर प्लान में डिज़ाइन, बिल्ड, लॉन्च और सपोर्ट शामिल है।",
      monthly: "एक बार का भुगतान",
      popular: "सबसे लोकप्रिय",
      cta: "शुरू करें",
      urgencyBadge: "🎁 सीमित समय का ऑफ़र",
      finePrint: "* सालाना मेंटेनेंस अलग से लिया जाता है",
      tiers: [
        {
          name: "Starter",
          price: "₹4,999",
          tag: "दुकान और अकेले मालिक के लिए",
          urgency: "इस प्लान के साथ 1 महीना फ्री सोशल मीडिया (पोस्ट + पोस्टिंग)",
          features: [
            "सुंदर 1-पेज वेबसाइट",
            "मोबाइल पर शानदार दिखती है",
            "WhatsApp और कॉल बटन",
            "कोई मासिक सर्वर ख़र्च नहीं",
            "3–7 दिनों में लाइव",
            "30 दिन फ्री सपोर्ट",
          ],
          fineprint: "सालाना मेंटेनेंस अलग से (बहुत कम)",
        },
        {
          name: "Growth",
          price: "₹14,999",
          tag: "बढ़ते हुए बिज़नेस के लिए",
          features: [
            "5-पेज प्रीमियम वेबसाइट",
            "लोगो + ब्रांड किट",
            "Instagram + Google बिज़नेस सेटअप",
            "8 सोशल पोस्ट (1 महीना फ्री)",
            "लीड फॉर्म + WhatsApp चैट",
            "Google सर्च में दिखेंगे",
            "60 दिन सपोर्ट",
          ],
        },
        {
          name: "Pro",
          price: "₹29,999",
          tag: "सॉफ्टवेयर, e-commerce और डायनमिक ऐप के लिए",
          features: [
            "कस्टम बिज़नेस सॉफ्टवेयर / ऐप",
            "ऑनलाइन शॉप / e-commerce रेडी",
            "कस्टमर लॉगिन और डैशबोर्ड",
            "ऑनलाइन पेमेंट (UPI, कार्ड)",
            "पूरा ब्रांडिंग पैकेज",
            "20 पोस्ट/महीना — 3 महीनों के लिए",
            "फाउंडर डिलीवरी और प्राइवेट सपोर्ट",
          ],
        },
      ],
      custom: {
        eyebrow: "कुछ अलग चाहिए?",
        title: "हम कस्टम प्लान भी बनाते हैं।",
        sub: "अनोखा आइडिया? बड़ी ज़रूरत? हम आपके बिज़नेस और बजट के लिए परफ़ेक्ट प्लान बनाएंगे।",
        cta: "कस्टम प्लान पाएं",
        bullets: ["आपकी ज़रूरत के हिसाब से", "फाउंडर से सीधी बातचीत", "मुफ्त 15 मिनट कंसल्टेशन"],
      },
    },
    testimonials: {
      eyebrow: "भारतीय बिज़नेस का प्यार",
      title: "असली मालिकों की कहानियाँ।",
      list: [
        { n: "रोहित मेहता", r: "मालिक, Bombay Brew Cafe", q: "वेबसाइट और Instagram 4 दिनों में तैयार। ग्राहक कहते हैं 'इम्पोर्टेड' लगती है! हर रुपया वसूल।", a: 1 },
        { n: "डॉ. प्रिया अय्यर", r: "फाउंडर, Iyer Wellness", q: "मुझे कहाँ से शुरू करना था पता नहीं था। Mitra टीम ने सब WhatsApp पर हैंडल किया। अब हफ्ते में 10+ ऑनलाइन बुकिंग।", a: 2 },
        { n: "अर्जुन सिंह", r: "मालिक, Iron Den Gym", q: "बाकी एजेंसियों ने ₹85,000 कोट किया था। इन्होंने ₹15,000 में बेहतर काम किया।", a: 3 },
        { n: "सान्वी खन्ना", r: "फाउंडर, Saanvi Boutique", q: "हर महीने जो Instagram पोस्ट बनाते हैं वो शानदार हैं। 60 दिनों में रीच तीन गुना हो गई।", a: 2 },
      ],
    },
    trust: {
      eyebrow: "Launch Mitra क्यों",
      title: "AI से तेज़। इंसानों का सपोर्ट। फाउंडर-नेतृत्व।",
      points: [
        { t: "तेज़ डिलीवरी", d: "ज़्यादातर प्रोजेक्ट 7 दिनों में लाइव।" },
        { t: "सच में सस्ती", d: "AI से एजेंसियों से 70% कम ख़र्च।" },
        { t: "WhatsApp पर असली लोग", d: "बॉट नहीं, असली इंसान बात करता है।" },
        { t: "फाउंडर क्वालिटी", d: "हर प्रोजेक्ट फाउंडर रिव्यू करते हैं।" },
        { t: "भारतीय SMB के लिए", d: "हिंदी + अंग्रेज़ी, UPI, WhatsApp इन-बिल्ट।" },
        { t: "पारदर्शी कीमत", d: "फ्लैट रेट। कोई छुपा ख़र्च नहीं।" },
      ],
    },
    cta: {
      title: "क्या आप अपना बिज़नेस ऑनलाइन लाने को तैयार हैं?",
      sub: "मुफ्त 15 मिनट की कॉल। कोई कमिटमेंट नहीं, कोई जटिलता नहीं।",
      primary: "मुफ्त कंसल्टेशन बुक करें",
      secondary: "WhatsApp करें",
    },
    form: {
      title: "चलिए आपका बिज़नेस लॉन्च करें",
      sub: "थोड़ी जानकारी दीजिए, हम 30 मिनट में कॉल करेंगे।",
      name: "आपका नाम",
      phone: "फ़ोन / WhatsApp",
      type: "बिज़नेस का प्रकार",
      typePh: "जैसे कैफ़े, क्लिनिक, जिम",
      message: "अपने बिज़नेस के बारे में बताइए (वैकल्पिक)",
      submit: "इन्क्वायरी भेजें",
      submitting: "भेज रहे हैं…",
      success: "धन्यवाद! 30 मिनट में WhatsApp पर कॉल आएगी।",
      error: "कुछ ग़लत हुआ। कृपया दोबारा कोशिश करें।",
    },
    footer: {
      tagline: "भारतीय SMB के लिए AI-संचालित डिजिटल लॉन्च पार्टनर।",
      sections: { product: "प्रोडक्ट", company: "कंपनी", contact: "संपर्क" },
      links: {
        services: "सेवाएं",
        pricing: "कीमत",
        portfolio: "उदाहरण",
        about: "हमारे बारे में",
        process: "प्रक्रिया",
        privacy: "प्राइवेसी",
      },
      rights: "सर्वाधिकार सुरक्षित।",
      built: "Launch Mitra द्वारा डिज़ाइन — अपने ही AI वर्कफ़्लो से।",
    },
    sticky: { call: "कॉल", whatsapp: "WhatsApp", launch: "लॉन्च करें" },
  },
};
